import { CorePressable} from '@/components/Theme/Core/CorePressable';
import { withStyles } from '@/components/Theme/Core/withStyles';

export const PressableRow = withStyles(CorePressable, {noSwitch: true, style: {flexDirection: 'row', display: 'flex'}});